import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ALL_NAV_ITEMS = [
  { to: '/', label: 'Dashboard', short: 'Board', exact: true, adminOnly: false },
  { to: '/projects', label: 'Projects', short: 'Projects', exact: false, adminOnly: true },
  { to: '/clients', label: 'Clients', short: 'Clients', exact: false, adminOnly: true },
  { to: '/prospects', label: 'Prospects', short: 'Prospects', exact: false, adminOnly: true },
  { to: '/notes', label: 'Notes', short: 'Notes', exact: false, adminOnly: true },
  { to: '/settings', label: 'Settings', short: 'Settings', exact: false, adminOnly: true },
];

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

  const isAdmin = (user?.role || 'admin') === 'admin';
  const navItems = ALL_NAV_ITEMS.filter((item) => !item.adminOnly || isAdmin);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initials = user?.name
    ? user.name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2)
    : 'U';

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        backdropFilter: 'blur(12px)',
        background: 'rgba(255,255,255,0.95)',
        borderBottom: '1px solid rgba(226,232,240,0.8)',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}
    >
      <div
        style={{
          maxWidth: '100%',
          margin: '0 auto',
          padding: isMobile ? '0 12px' : '0 24px',
          height: isMobile ? 48 : 60,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: isMobile ? 8 : 24,
        }}
      >
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <img
            src="/nwc-logo.png"
            alt="New Wave Creative"
            style={{ height: isMobile ? 32 : 54, width: 'auto', objectFit: 'contain' }}
          />
        </div>

        {/* Nav */}
        <nav style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 2 : 4, flex: isMobile ? 1 : undefined, justifyContent: isMobile ? 'center' : undefined }}>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.exact}
              style={({ isActive }) => ({
                padding: isMobile ? '5px 9px' : '6px 14px',
                borderRadius: 10,
                fontSize: isMobile ? 12 : 14,
                fontWeight: 500,
                textDecoration: 'none',
                color: isActive ? '#2563EB' : '#64748B',
                background: isActive ? '#EFF6FF' : 'transparent',
                transition: 'all 0.15s',
                whiteSpace: 'nowrap',
              })}
            >
              {isMobile ? item.short : item.label}
            </NavLink>
          ))}
        </nav>

        {/* User */}
        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 6 : 12, flexShrink: 0 }}>
          <div
            style={{
              width: isMobile ? 30 : 36,
              height: isMobile ? 30 : 36,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #2563EB 0%, #7C3AED 100%)',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 700,
              fontSize: isMobile ? 11 : 13,
              cursor: 'default',
            }}
            title={user?.email}
          >
            {initials}
          </div>
          <button
            onClick={handleLogout}
            className="btn btn-ghost btn-sm"
            title="Logout"
            style={{ padding: isMobile ? '5px' : undefined }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
            {!isMobile && 'Logout'}
          </button>
        </div>
      </div>
    </header>
  );
}
